import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "instruction-overlay"
}
const _hoisted_2 = { class: "row items-center no-wrap" }
const _hoisted_3 = { class: "text-blue-brand text-bold" }
const _hoisted_4 = { class: "instruction-icon q-mb-sm" }
const _hoisted_5 = { class: "text-body1" }
const _hoisted_6 = { class: "row items-start no-wrap text-caption text-grey-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_q_card, { class: "instruction-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "q-pb-none" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
                        _createVNode(_component_q_space),
                        _createVNode(_component_q_btn, {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "close",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_q_icon, {
                          name: _ctx.icon,
                          size: "64px",
                          color: "blue-brand"
                        }, null, 8, ["name"])
                      ]),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.message), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.tip)
                    ? (_openBlock(), _createBlock(_component_q_card_section, {
                        key: 0,
                        class: "q-pt-none"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_q_icon, {
                              name: "lightbulb",
                              size: "18px",
                              class: "q-mr-xs",
                              color: "amber-8"
                            }),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.tip), 1),
                              (_ctx.tipActionLabel)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "#",
                                    class: "tip-action-link",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('tip-action')), ["prevent"]))
                                  }, _toDisplayString(_ctx.tipActionLabel), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.actionLabel)
                    ? (_openBlock(), _createBlock(_component_q_card_section, {
                        key: 1,
                        class: "q-pt-none text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_btn, {
                            flat: "",
                            "no-caps": "",
                            color: "primary",
                            icon: _ctx.actionIcon,
                            label: _ctx.actionLabel,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('action')))
                          }, null, 8, ["icon", "label"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}